import { Box, Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

import MenuOrderFormItems from "./Items";

import { MenuOrderItemWithAppearance } from "shared-ui/MenuOrder/utils";
import { PickupTime } from "shared-ui/MenuOrder/usePickupTimeState";
import { KDSOrderDiningOption } from "apps/web/src/views/KDS/utils";
import { MenuOrderItemStatus } from "../../../types";
import { OrderStatusIcon } from "../OrderStatusIcon";
import DiningOptionSelect from "./DiningOptionSelect";
import TimePicker from "./TimePicker";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    timePicker: {
      width: '100%',
    },
  })
);

interface MenuOrderFormForOrderProps {
  menuOrderItems: readonly MenuOrderItemWithAppearance[];
  selectedItemId: string | null;
  onSelectItem: (item: MenuOrderItemWithAppearance) => void;
  onRemoveItem: (menuOrderItemId: string) => void;
  pickupTime: PickupTime | null;
  orderPickupTimes: PickupTime[];
  onChangePickupTime: (pickupTime: PickupTime) => void;
  mealMenuTimezone: string;
  menuOrderingClosed: boolean;
  orderStatus?: MenuOrderItemStatus;
  orderCode?: string;
  openTimePicker?: boolean;
  disabled?: boolean;
  setDiningOption?: (diningOption: KDSOrderDiningOption) => void;
  diningOption?: KDSOrderDiningOption;
}

const MenuOrderFormForOrder = ({
  onRemoveItem,
  menuOrderItems,
  menuOrderingClosed,
  orderCode,
  orderStatus,
  onChangePickupTime,
  pickupTime,
  orderPickupTimes,
  mealMenuTimezone,
  selectedItemId,
  onSelectItem,
  openTimePicker,
  disabled,
  setDiningOption,
  diningOption
}: MenuOrderFormForOrderProps) => {
  const classes = useStyles();

  return (
    <>
      <Box>
        {orderCode ? (
          <div>
            <Typography variant="h3">
              <strong>Order #{orderCode}</strong>
            </Typography>
            {orderStatus !== "new" && (
              <Box sx={{ orderStatus: {} }}>
                <OrderStatusIcon orderStatus={orderStatus} />
                <Typography>
                  <em>{orderStatus}</em>
                </Typography>
              </Box>
            )}
          </div>
        ) : (
          <Typography variant="h3">
            <strong>Order Details</strong>
          </Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <TimePicker
          className={classes.timePicker}
          forOrder={true}
          pickupTime={pickupTime}
          onChangePickupTime={onChangePickupTime}
          pickupTimes={orderPickupTimes}
          mealMenuTimezone={mealMenuTimezone}
          disabled={disabled || menuOrderingClosed}
          openTimePicker={openTimePicker}
        />
        {setDiningOption && <DiningOptionSelect onChangeOption={setDiningOption} diningOption={diningOption} disabled={disabled || menuOrderingClosed} />}
      </Box>
      <MenuOrderFormItems
        selectedItemId={selectedItemId}
        onSelectItem={onSelectItem}
        onRemoveItem={onRemoveItem}
        menuOrderItems={menuOrderItems}
        disabled={disabled || menuOrderingClosed}
      />
    </>
  );
};

export default MenuOrderFormForOrder;
